import * as motion from 'motion/react-client';
import type { CSSProperties } from 'react';

interface BlurOverlaysProps {
  hoveredSection: 'left' | 'right' | null;
  expandedSection: 'left' | 'right' | null;
}

const BlurOverlays = ({ hoveredSection, expandedSection }: BlurOverlaysProps) => {
  if (expandedSection) {
    return null;
  }

  const getBlurOverlayStyles = (side: 'left' | 'right'): CSSProperties => ({
    position: 'absolute' as const,
    top: 0,
    [side]: 0,
    width: '50%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    backdropFilter: 'blur(10px)',
    mask:
      side === 'left'
        ? 'linear-gradient(to left, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 80%, rgba(0,0,0,0.2) 100%)'
        : 'linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 80%, rgba(0,0,0,0.2) 100%)',
    WebkitMask:
      side === 'left'
        ? 'linear-gradient(to left, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 80%, rgba(0,0,0,0.2) 100%)'
        : 'linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 80%, rgba(0,0,0,0.2) 100%)',
    pointerEvents: 'none' as const,
    zIndex: 2,
  });

  return (
    <>
      <motion.div
        style={getBlurOverlayStyles('left')}
        initial={{ opacity: 0 }}
        animate={{ opacity: hoveredSection === 'right' ? 1 : 0 }}
        transition={{ duration: 0.1 }}
      />
      <motion.div
        style={getBlurOverlayStyles('right')}
        initial={{ opacity: 0 }}
        animate={{ opacity: hoveredSection === 'left' ? 1 : 0 }}
        transition={{ duration: 0.1 }}
      />
    </>
  );
};

export default BlurOverlays;
